import { gql } from "@apollo/client";
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import { useQuery } from "@apollo/client/react";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { PlatformCdnFile } from "../gql/graphql";

export const usePages = () => {
  const platformId = useParams().platformId;
  const [pages, setPages] = useState<Record<string, PlatformCdnFile>>();

  const {
    loading,
    error,
    data: pageData,
  } = useQuery(
    gql`
      query ($platformId: ID!) {
        platformFiles(platformId: $platformId, type: PAGE) {
          id
          pageConfig {
            path
          }
        }
      }
    ` as TypedDocumentNode<{ platformPages: PlatformCdnFile[] }>,
    {
      variables: {
        platformId,
      },
    },
  );

  useEffect(() => {
    if (pageData) {
      const pages: Record<string, PlatformCdnFile> = {};
      pageData.platformPages.forEach((page: any) => {
        pages[page.id] = page;
      });
      setPages(pages);
    }
  }, [pageData]);

  return {
    pages,
    loading,
    error,
  };
};

export const usePage = (pageId: string) => {
  const { pages, loading, error } = usePages();
  return {
    page: pages?.[pageId],
    loading,
    error,
  };
};

export const useEditorConfig = (pageId: string) => {
  const { data, loading, error } = useQuery<{ platformPage: PlatformCdnFile }>(
    gql`
      query ($id: ID!) {
        platformFile(id: $id) {
          pageConfig {
            path
          }
        }
      }
    `,
    {
      variables: {
        id: pageId,
      },
    },
  );

  return {
    page: data?.platformPage,
    loading,
    error,
  };
};
